<template>
  <div class="lighter-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>冲击力 → 极高电压 (kV)</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Mechanism House -->
          <rect x="150" y="40" width="100" height="160" fill="#222" stroke="#444" rx="5" />
          
          <!-- Piezoelectric Ceramic -->
          <rect x="180" y="100" width="40" height="40" fill="#00d2ff" stroke="#fff" />
          <text x="182" y="125" fill="#fff" font-size="8">PZT陶瓷</text>

          <!-- Hammer (Striker) -->
          <g :transform="`translate(200, ${hammerY})`">
             <rect x="-15" y="-30" width="30" height="30" fill="#aaa" />
             <text x="-12" y="-15" fill="#333" font-size="8" font-weight="bold">重锤</text>
          </g>

          <!-- Spark Gap -->
          <g transform="translate(300, 120)">
             <line x1="-30" y1="0" x2="-5" y2="0" stroke="#888" stroke-width="2" />
             <line x1="30" y1="0" x2="5" y2="0" stroke="#888" stroke-width="2" />
             <!-- The Spark -->
             <path v-if="sparking" :d="sparkPath" fill="none" stroke="#fff" stroke-width="2" />
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>状态: {{ status }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button type="danger" size="mini" @click="ignite">按下点火器 (Strike!)</el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>普通的电子点火器内部并没有电池，而是利用了**压电效应**。核心是一个压电陶瓷（如PZT）。当你按下开关时，内部弹簧被压缩并突然释放，重锤猛烈撞击陶瓷。瞬间的巨大压力使其表面产生数千伏的高压，通过放电针产生火花，足以点燃燃气。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PiezoelectricLighterViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      hammerY: 80,
      sparking: false,
      status: '就绪'
    }
  },
  computed: {
    sparkPath() {
       return `M -5,0 L 0,${(Math.random()-0.5)*10} L 5,0`;
    }
  },
  methods: {
    ignite() {
       this.status = '撞击中...';
       // Hammer falling
       this.hammerY = 100;
       setTimeout(() => {
          this.sparking = true;
          this.status = '产生高压火花！';
          setTimeout(() => {
             this.sparking = false;
             this.hammerY = 80;
             this.status = '就绪';
          }, 300);
       }, 50);
    }
  }
}
</script>

<style scoped lang="scss">
.lighter-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
